module.exports = __webpack_public_path__ + "static/media/CFI.90237095.png";